import ModalContext from 'components/explore/prospector/Dialog/context';
import SimpleDialog from 'components/explore/prospector/Dialog/SimpleDialog';
import React, { useState } from 'react';

const SimpleDialogProvider = ({ children }) => {
    const [onClose, setOnClose] = useState(null);
    const [open, setOpen] = useState(false);
    const [dialogProps, setDialogProps] = useState({});

    const showDialog = data => {
        return new Promise(resolve => {
            const onCloseCallback = success => {
                if (success === true) {
                    resolve(true);
                    setOpen(false);
                    setOnClose(null);
                } else if (success === false) {
                    resolve(false);
                    setOpen(false);
                    setOnClose(null);
                }
            };
            setDialogProps(data);
            setOnClose({ close: onCloseCallback });
            setOpen(true);
        });
    };
    return (
        <ModalContext.Provider value={showDialog}>
            <SimpleDialog
                {...dialogProps}
                open={open}
                onClose={onClose && onClose.close}
            />
            {children}
        </ModalContext.Provider>
    );
};

export default SimpleDialogProvider;
